import { config } from "core/config/app"

export const API_RECIPE_REQUEST = `${config.apiPrefix}/${config.apiVersion}/recipe/request`
export const API_RECIPE_LIST = `${config.apiPrefix}/${config.apiVersion}/recipe/request/:id`
export const API_RECIPE_DETAIL = `${config.apiPrefix}/${config.apiVersion}/recipe/:id`
export const API_SEARCH_RECIPE = `${config.apiPrefix}/${config.apiVersion}/recipe/search`
export const API_SEARCH_AI_RECIPE = `${config.apiPrefix}/${config.apiVersion}/recipe/suggestion`
